import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor(private http: HttpClient) { }

  getNMSversion = () :  Observable<string> => {
    return this.http.get<string>(`${environment.api.baseUrl}/${environment.api.endpoints.config.config}${environment.api.endpoints.config.version}`);
  }
}
